import { configureStore } from '@reduxjs/toolkit';

export const defaultState = {
  curPage: "loading",
  curBackground: "random"
}

function pageReducer(state = defaultState.curPage, action: {type: string, page: string}) {
  switch (action.type) {
    case "page/set":
      return action.page;
    default:
      return state
  }
}

function backgroundReducer(state = defaultState.curBackground, action: {type: string, bg: string}) {
  switch (action.type) {
    case "background/set":
      return action.bg;
    default:
      return state
  }
}

export const store = configureStore({
  reducer: {
    curPage: pageReducer,
    curBackground: backgroundReducer
  },
});
